export default __webpack_public_path__ + "static/media/bn.ad7aafa9.svg";